import { createListFilters } from '../../../../../components'

export type FaturaProfissionalAtendimentosFilters = {
  protocolo: string
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<FaturaProfissionalAtendimentosFilters>({
    protocolo: '',
  })
